import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    smsLogs: [],
    isLoading: false,
};

const SmsMessageLogSlice = createSlice({
    name: "smsMessageLog",
    initialState,
    reducers: {
        initiateSmsMessageLogLoader: (state, action) => {
            state.isLoading = action.payload;
        },
        getSmsMessageLogSuccess: (state, action) => {
            state.smsLogs = action.payload;
            state.isLoading = false;
        },
        clearSmsMessageLog: (state) => {
            state.smsLogs = [];
        },
    },
});

export const {
    initiateSmsMessageLogLoader,
    getSmsMessageLogSuccess,
    clearSmsMessageLog,
} = SmsMessageLogSlice.actions;

export const getSmsMessageLogSelector = (state) => state.smsMessageLog;

export default SmsMessageLogSlice.reducer;